export default __webpack_public_path__ + "static/media/grey-background-pattern.c540db20.svg";